import Vue from 'vue'
import Router from 'vue-router'
import Core from '@/components/Core'
import System from '@/components/System'
import Master from '@/components/Master'
import Logs from '@/components/Logs'
import Employee from '@/components/HRM/Employee'
import Application from '@/components/HRM/Application'
import Pos from '@/components/HRM/Pos'
import Shift from '@/components/HRM/Shift'
import Liff from '@/components/Liff'
import CheckINOUT from '@/components/HRM/CheckINOUT'
import ReportCovid from '@/components/HRM/ReportCovid'
import Leave from '@/components/HRM/Leave'
import HRSystem from '@/components/HRM/System'
import Approve from '@/components/HRM/Approve'
import Dashbord from '@/components/Dashbord'
import OT from '@/components/HRM/Overtime'
import Event from '@/components/HRM/Event'
import Special from '@/components/HRM/Special'
import Welfare from '@/components/HRM/Welfare'
import EmpPerformance from '@/components/HRM/EmpPerformance'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '*',
    component: Core.Login
  },
  {
    path: '/HRM/Overtime/OTDataRequest',
    name: 'OTDataRequest',
    component: OT.OTDataRequest
  },
  {
    path: '/HRM/Overtime/OTDataBranch',
    name: 'OTDataBranch',
    component: OT.OTDataBranch
  },
  {
    path: '/HRM/Employee/EmployeeCheckList',
    name: 'EmployeeCheckList',
    component: Employee.EmployeeCheckList
  },
  {
    path: '/HRM/Employee/EmployeeApprentice',
    name: 'EmployeeApprentice',
    component: Employee.EmployeeApprentice
  },
  {
    path: '/HRM/Employee/EmployeeImport',
    name: 'EmployeeImport',
    component: Employee.EmployeeImport
  },
  {
    path: '/HRM/Employee/EmployeeApprove',
    name: 'EmployeeApprove',
    component: Employee.EmployeeApprove
  },
  {
    path: '/HRM/Employee/EvaluateEmployee',
    name: 'EvaluateEmployee',
    component: Employee.EvaluateEmployee
  },
  {
    path: '/HRM/Employee/EvaluateEmployeeEdit',
    name: 'EvaluateEmployeeEdit',
    component: Employee.EvaluateEmployeeEdit
  },
  {
    path: '/HRM/Employee/EmployeeIssueInfomation',
    name: 'EmployeeIssueInfomation',
    component: Employee.EmployeeIssueInfomation
  },
  {
    path: '/Core/LoginFailed',
    name: 'LoginFailed',
    component: Core.LoginFailed
  },
  {
    path: '/Dashbord/DashbordCheckInOut',
    name: 'DashbordCheckInOut',
    component: Dashbord.DashbordCheckInOut
  },
  {
    path: '/Dashbord/DashbordLeave',
    name: 'DashbordLeave',
    component: Dashbord.DashbordLeave
  },
  {
    path: '/Dashbord/DashbordResign',
    name: 'DashbordResign',
    component: Dashbord.DashbordResign
  },
  {
    path: '/Dashbord/DashbordPosition',
    name: 'DashbordPosition',
    component: Dashbord.DashbordPosition
  },
  {
    path: '/Dashbord/DashbordCovid',
    name: 'DashbordCovid',
    component: Dashbord.DashbordCovid
  },
  {
    path: '/Dashbord/DashBoardView',
    name: 'DashBoardView',
    component: Dashbord.DashBoardView
  },
  {
    path: '/Dashbord/DashBoardViewEducationLevelEmp',
    name: 'DashBoardViewEducationLevelEmp',
    component: Dashbord.DashBoardViewEducationLevelEmp
  },
  {
    path: '/Dashbord/DashBoardViewRegionEmp',
    name: 'DashBoardViewRegionEmp',
    component: Dashbord.DashBoardViewRegionEmp
  },
  {
    path: '/Dashbord/DashBoardStatusEmp',
    name: 'DashBoardStatusEmp',
    component: Dashbord.DashBoardStatusEmp
  },
  {
    path: '/Dashbord/DashBoardLocition',
    name: 'DashBoardLocition',
    component: Dashbord.DashBoardLocation
  },
  {
    path: '/Dashbord/DashBoardLeave',
    name: 'DashBoardLeave',
    component: Dashbord.DashBoardLeave
  },
  {
    path: '/Dashbord/DashBoardAgeRangeEmp',
    name: 'DashBoardAgeRangeEmp',
    component: Dashbord.DashBoardAgeRangeEmp
  },
  {
    path: '/Dashbord/DashBoardAdjustINOUT',
    name: 'DashBoardAdjustINOUT',
    component: Dashbord.DashBoardAdjustINOUT
  },
  {
    path: '/Dashbord/DashBoardOT',
    name: 'DashBoardOT',
    component: Dashbord.DashBoardOT
  },
  {
    path: '/HRM/Employee/EmployeeInfo',
    name: 'EmployeeInfo',
    component: Employee.EmployeeInfo
  },
  {
    path: '/HRM/Employee/EmployeeManage',
    name: 'EmployeeManage',
    component: Employee.EmployeeManage
  },
  {
    path: '/HRM/Employee/EmployeeManageGA',
    name: 'EmployeeManageGA',
    component: Employee.EmployeeManageGA
  },
  {
    path: '/HRM/Employee/EmployeeUploadFile',
    name: 'EmployeeUploadFile',
    component: Employee.EmployeeUploadFile
  },
  {
    path: '/HRM/Employee/EmployeeAddress',
    name: 'EmployeeAddress',
    component: Employee.EmployeeAddress
  },
  {
    path: '/HRM/Employee/EmployeeFamily',
    name: 'EmployeeFamily',
    component: Employee.EmployeeFamily
  },
  {
    path: '/HRM/Employee/EmployeeEducation',
    name: 'EmployeeEducation',
    component: Employee.EmployeeEducation
  },
  {
    path: '/HRM/Employee/EmployeeExperience',
    name: 'EmployeeExperience',
    component: Employee.EmployeeExperience
  },
  {
    path: '/HRM/Employee/EmployeeCer',
    name: 'EmployeeCer',
    component: Employee.EmployeeCer
  },
  {
    path: '/HRM/Employee/EmployeeCerLevel',
    name: 'EmployeeCerLevel',
    component: Employee.EmployeeCerLevel
  },
  {
    path: '/HRM/Employee/EmployeeLanguageSkill',
    name: 'EmployeeLanguageSkill',
    component: Employee.EmployeeLanguageSkill
  },
  {
    path: '/HRM/Employee/EmployeePrivacy',
    name: 'EmployeePrivacy',
    component: Employee.EmployeePrivacy
  },
  {
    path: '/HRM/Employee/EmployeeSso',
    name: 'EmployeeSso',
    component: Employee.EmployeeSso
  },
  {
    path: '/HRM/Employee/EmployeeComputerSkill',
    name: 'EmployeeComputerSkill',
    component: Employee.EmployeeComputerSkill
  },
  {
    path: '/HRM/Employee/EmployeeJobExperience',
    name: 'EmployeeJobExperience',
    component: Employee.EmployeeJobExperience
  },
  {
    path: '/HRM/Employee/EmployeePositionTransfer',
    name: 'EmployeePositionTransfer',
    component: Employee.EmployeePositionTransfer
  },
  {
    path: '/HRM/Employee/EmployeeInfoIssue',
    name: 'EmployeeInfoIssue',
    component: Employee.EmployeeInfoIssue
  },
  {
    path: '/HRM/Employee/EmployeeInfoMerge',
    name: 'EmployeeInfoMerge',
    component: Employee.EmployeeInfoMerge
  },
  {
    path: '/HRM/Employee/EmployeeProbation',
    name: 'EmployeeProbation',
    component: Employee.EmployeeProbation
  },
  {
    path: '/HRM/Employee/Export',
    name: 'Export',
    component: Employee.Export
  },
  {
    path: '/HRM/Employee/EmployeeResign',
    name: 'EmployeeResign',
    component: Employee.EmployeeResign
  },
  {
    path: '/HRM/Employee/EmployeeManageImage',
    name: 'EmployeeManageImage',
    component: Employee.EmployeeManageImage
  },
  {
    path: '/HRM/Pos/Position',
    name: 'Position',
    component: Pos.Position
  },
  {
    path: '/HRM/Pos/PositionImport',
    name: 'PositionImport',
    component: Pos.PositionImport
  },
  {
    path: '/HRM/Pos/PositionLevel',
    name: 'PositionLevel',
    component: Pos.PositionLevel
  },
  {
    path: '/HRM/Pos/PositionType',
    name: 'HRMPositionType',
    component: Pos.PositionType
  },
  {
    path: '/HRM/Pos/AppPrivacy',
    name: 'AppPrivacy',
    component: Pos.AppPrivacy
  },
  {
    path: '/HRM/Application/Applicant',
    name: 'Applicant',
    component: Application.Applicant
  },
  {
    path: '/Core/Login',
    name: 'Login',
    component: Core.Login
  },
  {
    path: '/Core/LoginPage',
    name: 'LoginPage',
    component: Core.LoginPage
  },
  {
    path: '/Core/Home',
    name: 'Home',
    component: Core.Home
  },
  {
    path: '/Core/LoginEmp',
    name: 'LoginEmp',
    component: Core.LoginEmp
  },
  {
    path: '/Core/LoginEmpCheckinfo',
    name: 'LoginEmpCheckinfo',
    component: Core.LoginEmpCheckinfo
  },
  {
    path: '/System/User',
    name: 'User',
    component: System.User
  },
  {
    path: '/System/UserTypeGroup',
    name: 'UserTypeGroup',
    component: System.UserTypeGroup
  },
  {
    path: '/System/Menu',
    name: 'Menu',
    component: System.Menu
  },
  {
    path: '/System/Privacy',
    name: 'Privacy',
    component: System.Privacy
  },
  {
    path: '/System/PrivacyCheck',
    name: 'PrivacyCheck',
    component: System.PrivacyCheck
  },
  {
    path: '/System/News',
    name: 'News',
    component: System.News
  },
  {
    path: '/System/NewsCheck',
    name: 'NewsCheck',
    component: System.NewsCheck
  },
  {
    path: '/System/Running',
    name: 'Running',
    component: System.Running
  },
  {
    path: '/System/ReportRun',
    name: 'ReportRun',
    component: System.ReportRun
  },
  {
    path: '/HRM/EmpPerformance/PerformanceChasten',
    name: 'PerformanceChasten',
    component: EmpPerformance.PerformanceChasten
  },
  {
    path: '/HRM/EmpPerformance/PerformanceAsset',
    name: 'PerformanceAsset',
    component: EmpPerformance.PerformanceAsset
  },
  {
    path: '/HRM/EmpPerformance/PerformanceEducate',
    name: 'PerformanceEducate',
    component: EmpPerformance.PerformanceEducate
  },
  {
    path: '/HRM/EmpPerformance/PerformanceReputation',
    name: 'PerformanceReputation',
    component: EmpPerformance.PerformanceReputation
  },
  {
    path: '/HRM/EmpPerformance/PerformanceIndicator',
    name: 'PerformanceIndicator',
    component: EmpPerformance.PerformanceIndicator
  },
  {
    path: '/HRM/Approve/ApprovePermission',
    name: 'ApprovePermission',
    component: Approve.ApprovePermission
  },
  {
    path: '/HRM/Approve/ApproveWelfare',
    name: 'ApproveWelfare',
    component: Approve.ApproveWelfare
  },
  {
    path: '/HRM/System/Users',
    name: 'Users',
    component: HRSystem.Users
  },
  {
    path: '/HRM/System/Menu',
    name: 'Menu',
    component: HRSystem.Menu
  },
  {
    path: '/HRM/System/UserTypeGroup',
    name: 'UserTypeGroup',
    component: HRSystem.UserTypeGroup
  },
  {
    path: '/HRM/System/IssueProblemManage',
    name: 'IssueProblemManage',
    component: HRSystem.IssueProblemManage
  },
  {
    path: '/Master/Occupation',
    name: 'Occupation',
    component: Master.Occupation
  },
  {
    path: '/Master/Title',
    name: 'Title',
    component: Master.Title
  },
  {
    path: '/Master/Nationality',
    name: 'Nationality',
    component: Master.Nationality
  },
  {
    path: '/Master/Application',
    name: 'Application',
    component: Master.Application
  },
  {
    path: '/Master/Channel',
    name: 'Channel',
    component: Master.Channel
  },
  {
    path: '/Master/EducationLevel',
    name: 'EducationLevel',
    component: Master.EducationLevel
  },
  {
    path: '/Master/Branch',
    name: 'Branch',
    component: Master.Branch
  },
  {
    path: '/Master/Company',
    name: 'Company',
    component: Master.Company
  },
  {
    path: '/Master/Group',
    name: 'Group',
    component: Master.Group
  },
  {
    path: '/Master/Segment',
    name: 'Segment',
    component: Master.Segment
  },
  {
    path: '/Master/Department',
    name: 'Department',
    component: Master.Department
  },
  {
    path: '/Master/Bank',
    name: 'Bank',
    component: Master.Bank
  },
  {
    path: '/Master/PositionType',
    name: 'MasterPositionType',
    component: Master.PositionType
  },
  {
    path: '/Master/AddressType',
    name: 'AddressType',
    component: Master.AddressType
  },
  {
    path: '/Master/Gender',
    name: 'Gender',
    component: Master.Gender
  },
  {
    path: '/Master/Hobby',
    name: 'Hobby',
    component: Master.Hobby
  },
  {
    path: '/Master/MaritalStatus',
    name: 'MaritalStatus',
    component: Master.MaritalStatus
  },
  {
    path: '/Master/Languages',
    name: 'Languages',
    component: Master.Languages
  },
  {
    path: '/Master/ComputerSkill',
    name: 'ComputerSkill',
    component: Master.ComputerSkill
  },
  {
    path: '/Master/MilitaryStatus',
    name: 'MilitaryStatus',
    component: Master.MilitaryStatus
  },
  {
    path: '/Master/EducationAcademy',
    name: 'EducationAcademy',
    component: Master.EducationAcademy
  },
  {
    path: '/Master/EducationGroup',
    name: 'EducationGroup',
    component: Master.EducationGroup
  },
  {
    path: '/Master/IncomeList',
    name: 'IncomeList',
    component: Master.IncomeList
  },
  {
    path: '/Master/ShiftTypeGroup',
    name: 'ShiftTypeGroup',
    component: Master.ShiftTypeGroup
  },
  {
    path: '/Master/ShiftChangeGroup',
    name: 'ShiftChangeGroup',
    component: Master.ShiftChangeGroup
  },
  {
    path: '/Master/OtType',
    name: 'OtType',
    component: Master.OtType
  },
  {
    path: '/Master/LeaveType',
    name: 'LeaveType',
    component: Master.LeaveType
  },
  {
    path: '/Master/LeaveLevel',
    name: 'LeaveLevel',
    component: Master.LeaveLevel
  },
  {
    path: '/Master/LeaveQuota',
    name: 'LeaveQuota',
    component: Master.LeaveQuota
  },
  {
    path: '/HRM/Welfare/WelfareType',
    name: 'WelfareType',
    component: Welfare.WelfareType
  },
  {
    path: '/Master/welfareQuota',
    name: 'welfareQuota',
    component: Master.welfareQuota
  },
  {
    path: '/HRM/Welfare/welfareRequest',
    name: 'welfareRequest',
    component: Welfare.welfareRequest
  },
  {
    path: '/HRM/Welfare/welfareRequestBranch',
    name: 'welfareRequestBranch',
    component: Welfare.welfareRequestBranch
  },
  {
    path: '/HRM/Welfare/WelfareManagerBranch',
    name: 'WelfareManagerBranch',
    component: Welfare.WelfareManagerBranch
  },
  {
    path: '/HRM/Welfare/WelfareAccountMoneyManagement',
    name: 'WelfareAccountMoneyManagement',
    component: Welfare.WelfareAccountMoneyManagement
  },
  {
    path: '/HRM/Welfare/WelfareManagerHR',
    name: 'WelfareManagerHR',
    component: Welfare.WelfareManagerHR
  },
  {
    path: '/HRM/Welfare/WelfareManageQuest',
    name: 'WelfareManageQuest',
    component: Welfare.WelfareManageQuest
  },
  {
    path: '/Master/Hospital',
    name: 'Hospital',
    component: Master.Hospital
  },
  {
    path: '/Master/TraningTypeINOUT',
    name: 'TraningTypeINOUT',
    component: Master.TraningTypeINOUT
  },
  {
    path: '/Master/TraningType',
    name: 'TraningType',
    component: Master.TraningType
  },
  {
    path: '/Master/TraningLocation',
    name: 'TraningLocation',
    component: Master.TraningLocation
  },
  {
    path: '/Master/PayrollType',
    name: 'PayrollType',
    component: Master.PayrollType
  },
  {
    path: '/Master/FamilyRelations',
    name: 'FamilyRelations',
    component: Master.FamilyRelations
  },
  {
    path: '/Master/ManageGroupInsurance',
    name: 'ManageGroupInsurance',
    component: Master.ManageGroupInsurance
  },
  {
    path: '/Master/ManageInsurance',
    name: 'ManageInsurance',
    component: Master.ManageInsurance
  },
  {
    path: '/Master/InsuranceCompany',
    name: 'InsuranceCompany',
    component: Master.InsuranceCompany
  },
  {
    path: '/Master/vaccine',
    name: 'vaccine',
    component: Master.vaccine
  },
  {
    path: '/Master/EmployeeLevel',
    name: 'EmployeeLevel',
    component: Master.EmployeeLevel
  },
  {
    path: '/Master/ManageDocument',
    name: 'ManageDocument',
    component: Master.ManageDocument
  },
  {
    path: '/Master/ManageHelp',
    name: 'ManageHelp',
    component: Master.ManageHelp
  },
  {
    path: '/Shift/ImportTimeShift',
    name: 'ImportTimeShift',
    component: Shift.ImportTimeShift
  },
  {
    path: '/Shift/ImportTimeShiftGA',
    name: 'ImportTimeShiftGA',
    component: Shift.ImportTimeShiftGA
  },
  {
    path: '/Shift/ImportTimeShiftBranch',
    name: 'ImportTimeShiftBranch',
    component: Shift.ImportTimeShiftBranch
  },
  {
    path: '/Shift/ImportTimeShiftHR',
    name: 'ImportTimeShiftHR',
    component: Shift.ImportTimeShiftHR
  },
  {
    path: '/Shift/manageShiftTransferDepartment',
    name: 'manageShiftTransferDepartment',
    component: Shift.manageShiftTransferDepartment
  },
  {
    path: '/Shift/manageShiftTransferBranch',
    name: 'manageShiftTransferBranch',
    component: Shift.manageShiftTransferBranch
  },
  {
    path: '/Shift/manageShiftTransfer',
    name: 'manageShiftTransfer',
    component: Shift.manageShiftTransfer
  },
  {
    path: '/Shift/reportShiftTransfer',
    name: 'reportShiftTransfer',
    component: Shift.reportShiftTransfer
  },
  {
    path: '/Shift/reportShiftTransferDepartment',
    name: 'reportShiftTransferDepartment',
    component: Shift.reportShiftTransferDepartment
  },
  {
    path: '/Shift/reportShiftTransferBranch',
    name: 'reportShiftTransferBranch',
    component: Shift.reportShiftTransferBranch
  },
  {
    path: '/CheckINOUT/ReportCheckINOUT',
    name: 'ReportCheckINOUT',
    component: CheckINOUT.ReportCheckINOUT
  },
  {
    path: '/CheckINOUT/ReportCheckINOUTLeader',
    name: 'ReportCheckINOUTLeader',
    component: CheckINOUT.ReportCheckINOUTLeader
  },
  {
    path: '/CheckINOUT/ReportCheckINOUTToday',
    name: 'ReportCheckINOUTToday',
    component: CheckINOUT.ReportCheckINOUTToday
  },
  {
    path: '/CheckINOUT/ReportCheckINOUTTodayLeader',
    name: 'ReportCheckINOUTTodayLeader',
    component: CheckINOUT.ReportCheckINOUTTodayLeader
  },
  {
    path: '/CheckINOUT/ReportCheckINOUTTodayBranch',
    name: 'ReportCheckINOUTTodayBranch',
    component: CheckINOUT.ReportCheckINOUTTodayBranch
  },
  {
    path: '/CheckINOUT/ManageCheckINOUT',
    name: 'ManageCheckINOUT',
    component: CheckINOUT.ManageCheckINOUT
  },
  {
    path: '/CheckINOUT/ManageCheckINOUTBranch',
    name: 'ManageCheckINOUTBranch',
    component: CheckINOUT.ManageCheckINOUTBranch
  },
  {
    path: '/CheckINOUT/AdjustRequest',
    name: 'AdjustRequest',
    component: CheckINOUT.AdjustRequest
  },
  {
    path: '/CheckINOUT/AdjustRequestBranch',
    name: 'AdjustRequestBranch',
    component: CheckINOUT.AdjustRequestBranch
  },
  {
    path: '/CheckINOUT/AdjustRequestHeader',
    name: 'AdjustRequestHeader',
    component: CheckINOUT.AdjustRequestHeader
  },
  {
    path: '/CheckINOUT/ManageCheckINOUTAdjust',
    name: 'ManageCheckINOUTAdjust',
    component: CheckINOUT.ManageCheckINOUTAdjust
  },
  {
    path: '/ReportCovid/Report',
    name: 'ReportCovid',
    component: ReportCovid.Report
  },
  {
    path: '/ReportCovid/ReportBranch',
    name: 'ReportBranch',
    component: ReportCovid.ReportBranch
  },
  {
    path: '/ReportCovid/ReportDashBoard',
    name: 'ReportDashBoard',
    component: ReportCovid.ReportDashBoard
  },
  {
    path: '/ReportCovid/ReportVaccine',
    name: 'ReportVaccine',
    component: ReportCovid.ReportVaccine
  },
  {
    path: '/ReportCovid/ReportDashBoardVacine',
    name: 'ReportDashBoardVacine',
    component: ReportCovid.ReportDashBoardVacine
  },
  {
    path: '/ReportCovid/ReportDashBoardVacineCategory',
    name: 'ReportDashBoardVacineCategory',
    component: ReportCovid.ReportDashBoardVacineCategory
  },
  {
    path: '/ReportCovid/ReportCovidHelp',
    name: 'ReportCovidHelp',
    component: ReportCovid.ReportCovidHelp
  },
  {
    path: '/ReportCovid/LineNotifyCovid',
    name: 'LineNotifyCovid',
    component: ReportCovid.LineNotifyCovid
  },
  {
    path: '/Logs/CRUD',
    name: 'CRUD',
    component: Logs.CRUD
  },
  {
    path: '/Logs/Auth',
    name: 'Auth',
    component: Logs.Auth
  },
  {
    path: '/Liff/Login',
    name: 'CheckInLogin',
    component: Liff.Login
  },
  {
    path: '/Liff/LoginInfo',
    name: 'LoginInfo',
    component: Liff.LoginInfo
  },
  {
    path: '/Liff/Home',
    name: 'Home',
    component: Liff.Home
  },
  {
    path: '/Liff/Attendance',
    name: 'Attendance',
    component: Liff.Attendance
  },
  {
    path: '/Liff/Info',
    name: 'Info',
    component: Liff.Info
  },
  {
    path: '/Liff/Info',
    name: 'Info',
    component: Liff.Info
  },
  {
    path: '/Liff/Checkin',
    name: 'Checkin',
    component: Liff.Checkin
  },
  {
    path: '/Liff/CheckINOffice',
    name: 'CheckINOffice',
    component: Liff.CheckINOffice
  },
  {
    path: '/Liff/CheckinSuccess',
    name: 'CheckinSuccess',
    component: Liff.CheckinSuccess
  },
  {
    path: '/Liff/RegisterWFH',
    name: 'RegisterWFH',
    component: Liff.RegisterWFH
  },
  {
    path: '/Liff/RiskAssessment',
    name: 'RiskAssessment',
    component: Liff.RiskAssessment
  },
  {
    path: '/Liff/AdjustCheckInCheckOut',
    name: 'AdjustCheckInCheckOut',
    component: Liff.AdjustCheckInCheckOut
  },
  // {
  //   path: '/Liff/RiskAssessmentCovidTest',
  //   name: 'RiskAssessmentCovidTest',
  //   component: Liff.RiskAssessmentCovidTest
  // },
  {
    path: '/Liff/RIskAssessmentOffice',
    name: 'RIskAssessmentOffice',
    component: Liff.RIskAssessmentOffice
  },
  {
    path: '/Liff/LoginRisk',
    name: 'LoginRisk',
    component: Liff.LoginRisk
  },
  {
    path: '/Liff/CheckinHistory',
    name: 'CheckinHistory',
    component: Liff.CheckinHistory
  },
  {
    path: '/Liff/AssessmentHistory',
    name: 'AssessmentHistory',
    component: Liff.AssessmentHistory
  },
  {
    path: '/Liff/VaccinHistory',
    name: 'VaccinHistory',
    component: Liff.VaccinHistory
  },
  {
    path: '/Liff/RegisterCovid',
    name: 'RegisterCovid',
    component: Liff.RegisterCovid
  },
  {
    path: '/Liff/CovidCheckHistory',
    name: 'CovidCheckHistory',
    component: Liff.CovidCheckHistory
  },
  {
    path: '/Liff/OTRequest',
    name: 'OTRequest',
    component: Liff.OTRequest
  },
  {
    path: '/Liff/SignUpForHelp',
    name: 'SignUpForHelp',
    component: Liff.SignUpForHelp
  },
  {
    path: '/Liff/CovidAddHelp',
    name: 'CovidAddHelp',
    component: Liff.CovidAddHelp
  },
  {
    path: '/Liff/RegisterCovidShow',
    name: 'RegisterCovidShow',
    component: Liff.RegisterCovidShow
  },
  {
    path: '/Liff/Leave',
    name: 'Leave',
    component: Liff.Leave
  },
  {
    path: '/Liff/LeavePrivilege',
    name: 'LeavePrivilege',
    component: Liff.LeavePrivilege
  },
  {
    path: '/Liff/LeaveHistory',
    name: 'LeaveHistory',
    component: Liff.LeaveHistory
  },
  {
    path: '/Liff/Team',
    name: 'Team',
    component: Liff.Team
  },
  {
    path: '/Liff/News',
    name: 'News',
    component: Liff.News
  },
  {
    path: '/Liff/NewsVgroup',
    name: 'NewsVgroup',
    component: Liff.NewsVgroup
  },
  {
    path: '/Liff/NewsToKnow',
    name: 'NewsToKnow',
    component: Liff.NewsToKnow
  },
  {
    path: '/Liff/NewsLatestNews',
    name: 'NewsLatestNews',
    component: Liff.NewsLatestNews
  },
  {
    path: '/Liff/NewsToActivity',
    name: 'NewsToActivity',
    component: Liff.NewsToActivity
  },
  {
    path: '/Liff/ShiftWorkEmp',
    name: 'ShiftWorkEmp',
    component: Liff.ShiftWorkEmp
  },
  {
    path: '/HRM/Leave/Quota',
    name: 'LeabeQuota',
    component: Leave.LeaveQuota
  },
  {
    path: '/HRM/Leave/LeaveRequest',
    name: 'LeaveRequest',
    component: Leave.LeaveRequest
  },
  {
    path: '/HRM/Leave/LeaveEmployeeApprove',
    name: 'LeaveEmployeeApprove',
    component: Leave.LeaveEmployeeApprove
  },
  {
    path: '/HRM/Leave/LeaveBranch',
    name: 'LeaveBranch',
    component: Leave.LeaveBranch
  },
  {
    path: '/HRM/Leave/LeaveData',
    name: 'LeaveData',
    component: Leave.LeaveData
  },
  {
    path: '/HRM/Leave/ReportLeave',
    name: 'ReportLeave',
    component: Leave.ReportLeave
  },
  {
    path: '/HRM/Leave/ReportLeaveBranch',
    name: 'ReportLeaveBranch',
    component: Leave.ReportLeaveBranch
  },
  {
    path: '/HRM/Leave/ReportLeaveDepartment',
    name: 'ReportLeaveDepartment',
    component: Leave.ReportLeaveDepartment
  },
  {
    path: '/HRM/Leave/LeaveQuotaEmp',
    name: 'LeaveQuotaEmp',
    component: Leave.LeaveQuotaEmp
  },
  {
    path: '/Liff/Privacy',
    name: 'Privacy',
    component: Liff.Privacy
  },
  {
    path: '/Liff/IssueProblem',
    name: 'IssueProblem',
    component: Liff.IssueProblem
  },
  {
    path: '/Liff/IssueProblemCars',
    name: 'IssueProblemCars',
    component: Liff.IssueProblemCars
  },
  {
    path: '/Liff/HomeEvent',
    name: 'HomeEvent',
    component: Liff.HomeEvent
  },
  {
    path: '/Liff/RequestDoc',
    name: 'RequestDoc',
    component: Liff.RequestDoc
  },
  {
    path: '/Liff/HomeSpecialRequest',
    name: 'HomeSpecialRequest',
    component: Liff.HomeSpecialRequest
  },
  {
    path: '/Liff/HomeWelfare',
    name: 'HomeWelfare',
    component: Liff.HomeWelfare
  },
  {
    path: '/Liff/ManualApp',
    name: 'ManualApp',
    component: Liff.ManualApp
  },
  {
    path: '/Liff/SocialInsurance',
    name: 'SocialInsurance',
    component: Liff.SocialInsurance
  },
  {
    path: '/Liff/GroupInsurance',
    name: 'GroupInsurance',
    component: Liff.GroupInsurance
  },
  {
    path: '/Liff/OtherInsurance',
    name: 'OtherInsurance',
    component: Liff.OtherInsurance
  },
  {
    path: '/Liff/WelfareMarriage',
    name: 'WelfareMarriage',
    component: Liff.WelfareMarriage
  },
  {
    path: '/Liff/WelfareMaternity',
    name: 'WelfareMaternity',
    component: Liff.WelfareMaternity
  },
  {
    path: '/Liff/WelfareFuneral',
    name: 'WelfareFuneral',
    component: Liff.WelfareFuneral
  },
  {
    path: '/Liff/WelfareTravelExpenses',
    name: 'WelfareTravelExpenses',
    component: Liff.WelfareTravelExpenses
  },
  {
    path: '/Liff/WelfareDiscountSpareParts',
    name: 'WelfareDiscountSpareParts',
    component: Liff.WelfareDiscountSpareParts
  },
  {
    path: '/Liff/WelfareDiscountWage',
    name: 'WelfareDiscountWage',
    component: Liff.WelfareDiscountWage
  },
  {
    path: '/Liff/WelfareHistoryEmp',
    name: 'WelfareHistoryEmp',
    component: Liff.WelfareHistoryEmp
  },
  {
    path: '/Liff/welfareDiscountAccessories',
    name: 'welfareDiscountAccessories',
    component: Liff.welfareDiscountAccessories
  },
  {
    path: '/Liff/HomeEmployee',
    name: 'HomeEmployee',
    component: Liff.HomeEmployee
  },
  {
    path: '/Liff/QuestionHistory',
    name: 'QuestionHistory',
    component: Liff.QuestionHistory
  },
  {
    path: '/Liff/RegisterEvent',
    name: 'RegisterEvent',
    component: Liff.RegisterEvent
  },
  {
    path: '/Liff/ShiftsTransfer',
    name: 'ShiftsTransfer',
    component: Liff.ShiftsTransfer
  },
  {
    path: '/Liff/ShiftsTransferRichmenu',
    name: 'ShiftsTransferRichmenu',
    component: Liff.ShiftsTransferRichmenu
  },
  {
    path: '/Liff/LoginShiftTransfer',
    name: 'LoginShiftTransfer',
    component: Liff.LoginShiftTransfer
  },
  {
    path: '/Liff/EmpFamily',
    name: 'EmpFamily',
    component: Liff.EmpFamily
  },
  {
    path: '/Liff/EmpAddress',
    name: 'EmpAddress',
    component: Liff.EmpAddress
  },
  {
    path: '/Liff/News',
    name: 'News',
    component: Liff.News
  },
  {
    path: '/Liff/QuestionnaireTrain',
    name: 'QuestionnaireTrain',
    component: Liff.QuestionnaireTrain
  },
  {
    path: '/Liff/QuestSuccess',
    name: 'QuestSuccess',
    component: Liff.QuestSuccess
  },
  {
    path: '/Liff/WelfareHistory',
    name: 'WelfareHistory',
    component: Liff.WelfareHistory
  },
  {
    path: '/Liff/WelfareHistoryHR',
    name: 'WelfareHistoryHR',
    component: Liff.WelfareHistoryHR
  },
  {
    path: '/Liff/WelfareHistoryBranch',
    name: 'WelfareHistoryBranch',
    component: Liff.WelfareHistoryBranch
  },
  {
    path: '/Liff/EmployeeAddHelp',
    name: 'EmployeeAddHelp',
    component: Liff.EmployeeAddHelp
  },
  {
    path: '/Liff/EmpInfomation',
    name: 'EmpInfomation',
    component: Liff.EmpInfomation
  },
  {
    path: '/HRM/Event/EventPunsukDataRequest',
    name: 'EventPunsukDataRequest',
    component: Event.EventPunsukDataRequest
  },
  {
    path: '/HRM/Event/EventPunsukFamily',
    name: 'EventPunsukFamily',
    component: Event.EventPunsukFamily
  },
  {
    path: '/HRM/Event/EventPunsukAddress',
    name: 'EventPunsukAddress',
    component: Event.EventPunsukAddress
  },
  {
    path: '/Liff/GetLocation',
    name: 'GetLocation',
    component: Liff.GetLocation
  },
  {
    path: '/HRM/Event/DashBoardEvenPunSuk',
    name: 'DashBoardEvenPunSuk',
    component: Event.DashBoardEvenPunSuk
  },
  {
    path: '/HRM/Special/SpecialRequestDocument',
    name: 'SpecialRequestDocument',
    component: Special.SpecialRequestDocument
  },
  {
    path: '/HRM/Special/SpecialRequestEmpHelp',
    name: 'SpecialRequestEmpHelp',
    component: Special.SpecialRequestEmpHelp
  },
  {
    path: '/HRM/Special/SpecialProblem',
    name: 'SpecialProblem',
    component: Special.SpecialProblem
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js